import React, { useState, useEffect, useRef } from 'react';
import { useRange } from 'react-instantsearch';
import RangeSlider from 'react-range-slider-input';
import 'react-range-slider-input/dist/style.css';
import { useOnClickOutside } from 'usehooks-ts';
import classNames from 'classnames';
import Translate from '../Translate/Translate';
import {
  ChevronDownIcon,
  ChevronUpIcon,
  MinusIcon,
} from '@heroicons/react/20/solid';

interface AlgoliaFacetRangeProps {
  facetName: string;
}

const AlgoliaFacetRange = ({ facetName }: AlgoliaFacetRangeProps) => {
  const { start, range, refine } = useRange({ attribute: facetName });
  const [currentMin, setCurrentMin] = useState(
    start[0] < range.min ? range.min : start[0],
  );
  const [currentMax, setCurrentMax] = useState(
    start[1] > range.max ? range.max : start[1],
  );
  const [isActive, setIsActive] = useState(false);
  const filterMenuRef = useRef(null);

  useEffect(() => {
    setCurrentMin(range.min);
    setCurrentMax(range.max);
  }, [range.min, range.max]);

  const handleClickOutside = () => {
    setIsActive(false);
  };

  useOnClickOutside(filterMenuRef, handleClickOutside);

  const setCurrentValues = (newValues) => {
    const newMin = Math.min(...newValues);
    const newMax = Math.max(...newValues);
    setCurrentMin(newMin < range.min ? range.min : newMin);
    setCurrentMax(newMax > range.max ? range.max : newMax);
  };

  const refineValues = () => {
    refine([currentMin, currentMax]);
  };

  const handleChangeMin = (e) => {
    if (e.target.value === '') currentMin;
    else setCurrentMin(e.target.value);
    refineValues();
  };
  const handleChangeMax = (e) => {
    if (e.target.value === '') currentMax;
    else setCurrentMax(e.target.value);
    refineValues();
  };
  const handelButtonClick = (newValues) => {
    const newMin = Math.min(...newValues);
    const newMax = Math.max(...newValues);
    const adjustedMin = newMin < range.min ? range.min : newMin;
    const adjustedMax = newMax > range.max ? range.max : newMax;
    setCurrentMin(adjustedMin);
    setCurrentMax(adjustedMax);
    refine([adjustedMin, adjustedMax]);
  };

  return (
    <div
      ref={filterMenuRef}
      className={classNames(
        'relative border-b lg:mr-3 lg:border-none cursor-pointer',
        {
          'pb-3 lg:pb-0': isActive,
        },
      )}
    >
      <div
        onClick={() => setIsActive(!isActive)}
        className={classNames(
          'flex py-2 items-center justify-between border-rgrey-light cursor-pointer w-full lg:w-fit lg:border lg:rounded-sm lg:px-3',
          {
            'border-black':
              range.min !== currentMin || range.max !== currentMax,
          },
        )}
      >
        <p
          className={classNames(
            'font-axi-bold text-xl leading-8 text-black uppercase lg:normal-case lg:text-s lg:leading-4 lg:font-axi-book',
            {
              'font-axi-bold!':
                range.min !== currentMin || range.max !== currentMax,
            },
          )}
        >
          {facetName === 'finalPrice' && (
            <Translate component="facet-range" keyword="price" />
          )}
        </p>
        {isActive ? (
          <>
            <ChevronUpIcon className="hidden lg:block lg:w-5 lg:h-5 lg:ml-2" />
            <MinusIcon className="lg:hidden w-6 h-6" />
          </>
        ) : (
          <ChevronDownIcon className="lg:w-5 lg:h-5 w-6 h-6 lg:ml-2" />
        )}
      </div>
      <div
        className={classNames(
          'lg:mt-0.5 lg:pt-6 lg:px-4 lg:pb-7 lg:bg-white lg:border lg:border-rgrey-light lg:rounded-sm lg:w-80 lg:absolute lg:z-10',
          {
            hidden: !isActive,
          },
        )}
      >
        <div className="mb-7 mt-4 h-4">
          <RangeSlider
            className=""
            min={range.min}
            max={range.max}
            value={[currentMin, currentMax]}
            onInput={(newValues) => {
              setCurrentValues(newValues);
            }}
            onRangeDragEnd={refineValues}
            onThumbDragEnd={refineValues}
          />
        </div>
        <div>
          <div className="flex px-0.5 flex-wrap gap-3 justify-start lg:justify-center">
            <button
              onClick={() => {
                handelButtonClick([0, 20]);
              }}
            >
              <div className="border rounded-sm px-4 py-2 max-w-20 hover:text-white hover:bg-black hover:border-black">
                kuni 20
              </div>
            </button>

            <button
              onClick={() => {
                handelButtonClick([0, 40]);
              }}
            >
              <div className="border rounded-sm px-4 py-2 max-w-20 hover:text-white hover:bg-black hover:border-black">
                kuni 40
              </div>
            </button>

            <button
              onClick={() => {
                handelButtonClick([0, 60]);
              }}
            >
              <div className="border rounded-sm px-4 py-2 max-w-20 hover:text-white hover:bg-black hover:border-black">
                kuni 60
              </div>
            </button>
          </div>
          <div className="h-auto flex">
            <input
              className="w-1/2 text-center p-2 bg-rgrey-lightmid border rounded-sm border-rgrey-light m-2 text-base leading-6 text-black"
              type="number"
              placeholder={currentMin.toString()}
              onChange={handleChangeMin}
              value={currentMin}
            />
            <input
              className="w-1/2 text-center p-2 bg-rgrey-lightmid border rounded-sm border-rgrey-light m-2 text-base leading-6 text-black"
              type="number"
              placeholder={currentMax.toString()}
              onChange={handleChangeMax}
              value={currentMax}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlgoliaFacetRange;
